module.exports = __webpack_public_path__ + "assets/img/news (47).308e0f0c.png";